module.exports = __webpack_public_path__ + "img/groupdefault.e0f450df.png";